import { Drawer } from '@mantine/core';
import { CreatorChallenge } from '../../../../types/challenges';
import {
  formatChallengeCompletedDate,
  getChallengeRewardTypeLabel,
  getChallengeTitle,
  getCompletedChallengeStatus,
} from '../../../../utils/challenge-utils';
import ChallengeStatusTag from './ChallengeStatusTag';
import styles from './allChallenges.module.css';

type RewardDetailsDrawerProps = {
  challenge: CreatorChallenge | null;
  defaultCurrency: string;
  onClose: () => void;
  onClaimReward: (challenge: CreatorChallenge) => void;
};

export default function RewardDetailsDrawer({
  challenge,
  defaultCurrency,
  onClose,
  onClaimReward,
}: RewardDetailsDrawerProps) {
  return (
    <Drawer
      opened={Boolean(challenge)}
      onClose={onClose}
      position="bottom"
      title="Reward Details"
      padding={0}
      size="auto"
      zIndex={1100}
      overlayProps={{ opacity: 0.4, color: '#000' }}
      styles={{
        content: {
          borderTopLeftRadius: 12,
          borderTopRightRadius: 12,
        },
        header: {
          justifyContent: 'center',
          padding: 16,
          borderBottom: '1px solid #eaecf0',
        },
        title: {
          fontSize: 14,
          fontWeight: 500,
          color: '#353535',
          textAlign: 'center',
          width: '100%',
        },
        close: {
          position: 'absolute',
          right: 14,
          top: 14,
        },
        body: {
          padding: '16px 0',
        },
      }}
    >
      {challenge && (
        <div className={styles.drawerContent}>
          <div className={styles.drawerRow}>
            <p className={styles.drawerLabel}>Challenge</p>
            <p className={styles.drawerValue}>{getChallengeTitle(challenge, defaultCurrency)}</p>
          </div>
          <div className={styles.drawerRow}>
            <p className={styles.drawerLabel}>Reward Type</p>
            <p className={styles.drawerValue}>{getChallengeRewardTypeLabel(challenge)}</p>
          </div>
          <div className={styles.drawerRow}>
            <p className={styles.drawerLabel}>Completed On</p>
            <p className={styles.drawerValue}>{formatChallengeCompletedDate(challenge.completedAt)}</p>
          </div>
          <div className={styles.drawerStatusRow}>
            <p className={styles.drawerLabel}>Reward Status</p>
            <ChallengeStatusTag
              status={getCompletedChallengeStatus(challenge)}
              onClaim={() => {
                onClose();
                onClaimReward(challenge);
              }}
            />
          </div>
        </div>
      )}
    </Drawer>
  );
}
